(function(){
  function init(){
    if(!document.body || !document.body.classList.contains('template-product')) return;
    if(document.querySelector('.luxe-mobile-sticky-atc')) return;
    var form=document.querySelector('form[action*="/cart/add"]');
    var add=form && (form.querySelector('button[name="add"]') || form.querySelector('input[name="add"]') || form.querySelector('button[type="submit"]'));
    if(!add) return;
    var title=document.querySelector('.product-single__title, .product__title, h1');
    var price=document.querySelector('.product-single__price, .product__price, [data-product-price]');
    var bar=document.createElement('div'); bar.className='luxe-mobile-sticky-atc';
    bar.innerHTML='<div class="luxe-mobile-sticky-atc__meta"><span class="luxe-mobile-sticky-atc__title"></span><span class="luxe-mobile-sticky-atc__price"></span></div><button type="button" class="luxe-mobile-sticky-atc__button">ADD TO CART</button>';
    if(title) bar.querySelector('.luxe-mobile-sticky-atc__title').textContent=title.textContent.trim();
    if(price) bar.querySelector('.luxe-mobile-sticky-atc__price').textContent=price.textContent.trim();
    var btn=bar.querySelector('button');
    btn.addEventListener('click',function(){
      add.scrollIntoView({behavior:'smooth',block:'center'});
      setTimeout(function(){ if(!add.disabled) add.click(); },250);
    });
    document.body.appendChild(bar);
    var sync=function(){ btn.disabled=!!add.disabled; if(add.textContent && /sold out|unavailable/i.test(add.textContent)) btn.textContent=add.textContent.trim(); else btn.textContent='ADD TO CART'; };
    sync();
    new MutationObserver(sync).observe(add,{attributes:true,childList:true,subtree:true});
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
})();
